export default {"src":"/_next/static/media/checked_secondary.340b49c1.svg","height":15,"width":14,"blurWidth":0,"blurHeight":0};